import './App.css';
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import axios from "axios";
import {Alert, AppRegistry, Button, StyleSheet, View } from 'react-native';  
import Update from './components/Update'
import Delete from './components/Delete'
let dotenv=require('dotenv')
const isImageUrl = require('is-image-url');
const isUrl= require('is-url');
dotenv.config()
class Upd extends React.Component {
  constructor(props) {
    super(props);
    this.state = {show:false,show2:false};
  }
 showModal2= e => {
 this.setState({show2:!this.state.show2});
 }
  showModal= e => {
  this.setState({show:!this.state.show});
  } 	
  render() {
    return (
      <div>
        <button onClick={e=>{this.showModal()}}>
			 Update Meme 
			 </button>
			 <Update memes={this.props.memes} onClose={this.showModal} show={this.state.show}/>
        <button onClick={e=>{this.showModal2()}}>
			 Delete Meme 
			 </button>
        <Delete memes={this.props.memes} onClose={this.showModal2} show={this.state.show2}/>
      </div>
    );
  }
}


class MemeList extends React.Component {
    render() {
        return (
        <div>
        	<h1>Meme Corner</h1>
        	<ul style={{listStyleType:"none"}}>
        	{ this.props.memes.length <=0?
        		'Make an entry to get the process going':
        		this.props.memes.map((meme) => (
        		<li style={{wordBreak:"break-all"}}  key={meme.id} id="lists">
        		 <p><strong >{meme.name}</strong></p>
        		 <p style={{padding:"10px 30px 10px 30px"}}>{meme.caption}</p>
        		<img src={meme.url} style={{maxHeight:"300px"}}/>
        		<Upd memes={meme}/>
        		</li>
        		))}
        	</ul>
        	</div>
        	);
        	}
        	}
      

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      memes: [],
      name: '',
      caption:'',
      url:'',
      errormessage : ''
          };
  }
  componentDidMount() {
         axios.get(`https://mymemeserver.herokuapp.com/memes`)
		.then((res) => {
		this.setState({memes: res.data});
		},(error) =>{
		console.log(error);
		}); 
    }
  mySubmitHandler = (event) => {
   event.preventDefault();
		const { name,caption,url} = this.state;
        axios(`https://mymemeserver.herokuapp.com/memes`, {
				  "method": "POST",
				  "headers": {
					"content-type": "application/json"
  					},
  				"data": JSON.stringify({
              name, caption, url,
  			})
			})
          .then((response) => {
 			 console.log(response);
 			 this.setState({errormessage : "Submitted meme successfully. Getting back to you in a couple of seconds",})
      		setTimeout(function(){window.location.reload();},3000);
			}, (error) => {
  			console.log(error.message);
    	this.setState({errormessage: "Not valid url or doesn't lead to an image."});
			})
		
     }
     myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;
    this.setState({[nam]: val});
  }
  render() {
    return (
    <div>
    <form  onSubmit={this.mySubmitHandler} >
    <div style={{height:"100%"}} className="ct">
      <h1>XMEME CORNER</h1>
      <p style={{height:"20px"}} id="heading">Username</p>
      <input
        type='text'
        name='name'
        placeholder='Enter your name'
        required
        onChange={this.myChangeHandler}
      />
      <p id="heading">Enter a caption</p>
      <input
        type='text'
        name='caption'
        placeholder='Get creative. Or wild. '
        required
        onChange={this.myChangeHandler}
      />
      <p id="heading">Enter url for image</p>
      <input
        type='text'
        name='url'
        placeholder='Enter a valid image url'
        required
        onChange={this.myChangeHandler}
      />
      <p><strong>{this.state.errormessage}</strong></p>
      <input type='submit' />
      </div>
      </form>
      < MemeList memes={this.state.memes} />
      </div>
    );
  }
}
export default App;


  
     

      
 
 
